import { Injectable, signal, WritableSignal } from "@angular/core";
import { ActionConfig, ActionConfigMapping } from "../../types/extjs-action.types";
import { Project } from "@core/types/sidebar.type";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { ExtjsMessageEvent } from "@core/components/pages/extjs/extjs.component";

@Injectable({ providedIn: "root" })
export class ExtjsService {
  isWildCardRouted: WritableSignal<boolean> = signal(false);

  wasWildCardRouted: WritableSignal<boolean> = signal(false);

  private _channels: Map<string, MessageChannel> = new Map<string, MessageChannel>([]);

  private _iframeHash$: BehaviorSubject<string> = new BehaviorSubject<string>("");

  private _message$: Subject<ExtjsMessageEvent> = new Subject<ExtjsMessageEvent>();

  public scope: WritableSignal<string | null> = signal(null);

  public message$: Observable<ExtjsMessageEvent> = this._message$.asObservable();

  get iframeHash$ (): Observable<string> {
    return this._iframeHash$.asObservable();
  }

  get channels (): Map<string, MessageChannel> {
    this._channels = new Map<string, MessageChannel>([
      [ "auth", new MessageChannel() ],
      [ "route", new MessageChannel() ],
      [ "action", new MessageChannel() ]
    ]);

    return this._channels;
  }


  /**
   * Notify subscribers of `message$`-Observable that given message is emitted
   * @param messageEvent Event-data of the Message
   */
  public notifyMessage (messageEvent: ExtjsMessageEvent): void {
    this._message$.next(messageEvent);
  }

  public setIframeHash (hash: string): void {
    this._iframeHash$.next(hash);
  }

  performAction (action: keyof ActionConfigMapping, project: Project | null): void {
    const config: ActionConfig = { action };
    const number: string | undefined = project?.number;
    const projectName: string | undefined = project?.name;

    switch (action) {
      case "createCustomerReport": {
        break;
      }

      case "createEmployeeReport": {
        break;
      }

      case "showLiveView": {
        if (!projectName)
          return;

        config.config = {
          projectNumber: number ?? "",
          projectName,
          left: 1220,
          top: 3
        };

        break;
      }

      default: {
        if (!number)
          return;

        config.config = { projectNumber: number };
      }
    }

    /* eslint-disable-next-line @tseslint/no-non-null-assertion */
    this._channels.get("action")!.port1.postMessage(config);
  }
}
